import Vue from "vue";

Vue.filter("first_name", function(value) {
  if (!value) {
    return "";
  }
  const firstName = value.trim().split(" ")[0];
  return firstName || "";
});
